<template>
  <el-card>
    <template v-slot:header>
      <div>
        <span class="mr-[40px]">服务包</span>
      </div>
    </template>

    <el-table ref="multipleTable" :data="serviceList" border>
      <el-table-column fixed prop="index" label="序号" width="70" type="index">
      </el-table-column>
      <el-table-column prop="name" label="服务包">
        <template v-slot="{ row }">
          <span>{{ row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="价格">
        <template v-slot="{ row }">
          <div class="whitespace-nowrap overflow-hidden overflow-ellipsis">
            {{ row.price }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="描述">
        <template v-slot="{ row }">
          <div class="whitespace-nowrap overflow-hidden overflow-ellipsis">
            {{ row.description }}
          </div>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作">
        <template v-slot="{ row }">
          <el-button @click="order(row)" type="primary" size="mini"
            >下单</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="text-center"
      layout="prev, pager, next"
      @current-change="handleCurrentChange"
      :total="total"
    >
    </el-pagination>
  </el-card>
</template>

<script>
import { fetchServiceList } from "@/api/api";
export default {
  name: "StaffPage",
  data() {
    return {
      serviceList: [],
      page: 1,
      limit: 10,
      total: 0,
    };
  },

  mounted() {
    this.getServiceList();
  },
  methods: {
    async getServiceList() {
      var params = {
        page: this.page,
        limit: this.limit,
      };
      try {
        let result = await fetchServiceList(params);

        if (result.data.code == 0) {
          this.serviceList = result.data.data.data;
          this.total = result.data.data.total;
        }
      } catch (err) {
        console.log(err);
      }
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getServiceList();
    },
    order() {
        this.$message.warning("服务包下单，请前往微信'E链签'小程序!");
    }
  },
};
</script>